import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Link, useParams } from "react-router-dom";
import { debounce } from "lodash";
import dayjs from "dayjs";
import { Trans, useTranslation } from "react-i18next";
import {
  Space,
  Select,
  DatePicker,
  Table,
  Input,
  Modal,
  Col,
  Form,
  Row,
  Popconfirm,
  Tooltip,
  Button,
  Popover,
  Breadcrumb,
} from "antd";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import SearchIcon from "../../../image/SearchIcon.svg";
import { ReactComponent as Archiveicon } from "../../../image/Archiveicon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import { getRequest, postRequest } from "../../../axios";
import moment from "moment";
// import OrderApprove from "../../../images/OrderApprove.svg";
import PendingActions from "../../../image/PendingActions.svg";
import OrderStage from "../../../image/OrderStage.svg";
import RfqFloat from "../../../image/RfqFloat.svg";
import TotalCount from "../../../image/TotalCount.svg";
import NegotiationStage from "../../../image/NegotiationStage.svg";
import OfferStage from "../../../image/OfferStage.svg";
import { ReactComponent as Archive } from "../../../image/Archive.svg";
import ComparativeScaleNew from "../../../image/ComparativeScaleNew.png";
import Comparativ from "../../../image/comparativ.png";
import { authUserData } from "../../../utils/Helper";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import {
  ClockCircleOutlined,
  EyeOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import "jspdf-autotable";
import DotRFQStatus from "../../PR/DotRFQStatus";
import SubscriptionNotification from "../../../authentication/SubscriptionNotification";

const ReportModule = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [rfqStatus, setRfqStatus] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const formRef = useRef();
  const onSearchRef = useRef(() => {});
  const inventorySearchDebouncedRef = useRef(
    debounce((value) => {
      onSearchRef.current(value);
    }, 1000)
  );
  const [selectedCard, setSelectedCard] = useState(null);
  const [clickedFilterButton, setClickedFilterButton] = useState(false);
  const formReFloatPriceRef = useRef();
  const [categoryTree, setCategoryTree] = useState([]);
  const [categoryTreeFilter, setCategoryTreeFilter] = useState("");
  const [vendorFilter, setVendorFilter] = useState(undefined);
  const { id } = useParams();
  const [categoryId, setCategoryId] = useState(null);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [loading, setLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [
    isWithOutRestrictionReFloatModalOpen,
    setIsWithOutRestrictionReFloatModalOpen,
  ] = useState(false);

  const [poWorkflowData, setPoWorkflowData] = useState([]);
  const [poWorkflowLoading, setPoWorkflowLoading] = useState(false);
  const [poWorkflowTotal, setPoWorkflowTotal] = useState(0);
  const [poWorkflowState, setPoWorkflowState] = useState({
    page: 1,
    page_size: 10,
  });
  const [poWorkflowFilters, setPoWorkflowFilters] = useState({});
  const [inventorySearch, setInventorySearch] = useState("");

  const isCompanyAdmin = authUserData()?.role?.some(
    (role) => role.name === "Company Admin"
  );
  const hasCompanyRole = authUserData()?.company_role === "Company Admin";

  const getPastDate = (days) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date;
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const shortYear = year % 100;
    return `${day}-${month}-${shortYear}`;
  };
  const dayMapping = {
    "2D": 1,
    "3D": 2,
    "5D": 4,
    "7D": 6,
    "1M": 29,
    All: 730,
  };
  const startDateFilter = formatDate(getPastDate(dayMapping["5D"]));
  const endDateFilter = formatDate(new Date());

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    rfq_created_date__gte: startDateFilter,
    rfq_created_date__lte: endDateFilter,
  });
  const [statusCounts, setStatusCounts] = useState({
    total_rfq: 0,
    approval_stage_count: 0,
    draft_pr_count: 0,
    negotiation_stage_count: 0,
    offer_stage_count: 0,
    order_placed_count: 0,
    rfq_cancelled_count: 0,
    rfq_floated_count: 0,
    rfq_hold_count: 0,
    rfq_under_approval_count: 0,
    total_po: 0,
    pending_po_count: 0,
    started_po_count: 0,
    complete_po_count: 0,
  });
  const [selectedPrNumber, setSelectedPrNumber] = useState(null);
  const [dotLoaded, setDotLoaded] = useState(false);

  const cleanQueryParams = (obj) =>
    Object.fromEntries(
      Object.entries(obj || {}).filter(
        ([, v]) => v !== undefined && v !== null && v !== ""
      )
    );

  const parseVendorStatusList = (res) => {
    const payload = res?.data;
    const count = payload?.count ?? 0;
    const results = payload?.results;
    const data =
      results?.data ?? payload?.data ?? payload?.results ?? payload ?? [];
    const list = Array.isArray(data) ? data : [];
    return { list, count };
  };

  const mapVendorStatusRows = (list, rowOffset = 0) =>
    list.map((item, idx) => ({
      key: item?.id ?? idx,
      id: item?.id ?? idx,
      srNo: item?.sr_no ?? rowOffset + idx + 1,
      invoiceChallanNo:
        item?.invoice_number ??
        item?.challan_number ??
        item?.document_number ??
        "—",
      supplierName: item?.supplier_name ?? "—",
      receiptDate: item?.receipt_date ?? "—",
      document_file_url: item?.document_file_url ?? null,
      min: item?.min,
      drafts: item?.drafts,
      good_receipt_list: item?.good_receipt_list,
      inspection: item?.inspection,
      distribution: item?.distribution,
      site_receipt_conf: item?.site_receipt_conf,
    }));

  const computePoCardCounts = (list, totalFromApi) => {
    const completed = list.filter(
      (i) => String(i?.site_receipt_conf || "").toLowerCase() === "completed"
    ).length;
    const pending = list.filter((i) => {
      const min = String(i?.min || "").toLowerCase();
      const site = String(i?.site_receipt_conf || "").toLowerCase();
      return min === "pending" && site !== "completed";
    }).length;
    const started = Math.max(0, list.length - completed - pending);
    return {
      total_po: totalFromApi ?? list.length,
      pending_po_count: pending,
      started_po_count: started,
      complete_po_count: completed,
    };
  };

  const fetchVendorStatus = async (requestParams = {}) => {
    try {
      setPoWorkflowLoading(true);
      const cleanedParams = cleanQueryParams(requestParams);

      const res = await getRequest(
        "vendor-wise-status/vendor_status/",
        cleanedParams
      );

      const parsed = parseVendorStatusList(res);
      const list = parsed.list;
      const totalFromApi =
        parsed.count > 0 ? parsed.count : list.length;
      setPoWorkflowTotal(totalFromApi);

      setStatusCounts((prev) => ({
        ...prev,
        ...computePoCardCounts(list, totalFromApi),
      }));

      const page = Number(cleanedParams.page) || 1;
      const pageSize = Number(cleanedParams.pagesize) || 10;
      const rowOffset = (page - 1) * pageSize;

      const mapped = mapVendorStatusRows(list, rowOffset);
      setPoWorkflowData(mapped);
    } catch (err) {
      console.error("Error fetching vendor status:", err);
      ErrorNotificationMsg(err?.response?.data?.error || "Failed to load vendor status");
      setPoWorkflowData([]);
      setPoWorkflowTotal(0);
    } finally {
      setPoWorkflowLoading(false);
    }
  };

  useEffect(() => {
    const params = cleanQueryParams({
      ...poWorkflowFilters,
      search: inventorySearch.trim() || undefined,
      page: poWorkflowState.page,
      pagesize: poWorkflowState.page_size,
    });
    fetchVendorStatus(params);
  }, [
    reload,
    poWorkflowFilters,
    poWorkflowState.page,
    poWorkflowState.page_size,
    inventorySearch,
  ]);

  useEffect(() => {
    const loadVendors = async () => {
      try {
        const response = await getRequest("vendors/");
        const rows = response?.data?.results;
        setVendors(Array.isArray(rows) ? rows : []);
      } catch (e) {
        console.error("Error loading vendors:", e);
        setVendors([]);
      }
    };
    loadVendors();
  }, []);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const handlePoWorkflowTableChange = (pagination) => {
    setPoWorkflowState((prev) => ({
      ...prev,
      page: pagination?.current ?? 1,
      page_size: pagination?.pageSize ?? prev.page_size,
    }));
  };

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }
    if (sortField === "rfq_number" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_number";
    }
    if (sortField === "rfq_number" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_number";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }
    if (sortField === "rfqstatus" && sortOrder === "ascend") {
      sortingEnumKey = "rfqstatus";
    }
    if (sortField === "rfqstatus" && sortOrder === "descend") {
      sortingEnumKey = "-rfqstatus";
    }

    return sortingEnumKey;
  };
  const handleStartDateChange = (date) => {
    if (!date) {
      setStartDate("");
      return;
    }
    setStartDate(moment(date).format("DD-MM-YY"));
  };

  const handleEndDateChange = (date) => {
    if (!date) {
      setEndDate("");
      return;
    }
    setEndDate(moment(date).format("DD-MM-YY"));
  };
  //
  const handleCategoryChange = (value) => {
    setCategoryTreeFilter(value);
  };
  const handleVendorChange = (value) => {
    setVendorFilter(value ?? undefined);
  };

  const handleReset = () => {
    setSelectedCard(null);
    setClickedFilterButton(false);
    setRfqStatus("");
    setEndDate("");
    setStartDate("");
    setCategoryTreeFilter("");
    setVendorFilter(undefined);
    setInventorySearch("");
    setPoWorkflowFilters({});
    setPoWorkflowState((prev) => ({ ...prev, page: 1 }));

    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
    });
    formRef.current.setFieldsValue({
      po_created_date__gte: null,
      pr_created_date__lte: null,
      pr_created_date__gte: null,
      rfq_created_date__gte: null,
      rfq_detail: null,
      category_id: null,
      vendor: null,
      rfq_created_date__lte: null,
    });
    form.setFieldsValue({ search: "" });
  };
  const handleClearFields = () => {
    setEndDate("");
    setStartDate("");
  };

  const handleRejectedChange = (value, index) => {
    setIsWithOutRestrictionReFloatModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setIsWithOutRestrictionReFloatModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsWithOutRestrictionReFloatModalOpen(false);
  };
  const handleReFloatPriceSubmit = async (values) => {
    // console.log(values);
  };
  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day");
  };
  const handleDatepickerChange = (date, dateString, fieldName) => {
    const formattedDateString = dateString
      ? moment(dateString, "DD MMMM YYYY HH:mm").format("DD-MM-YYYY HH:mm")
      : null;
  };

  const handleApplyVendorStatusFilter = () => {
    setPoWorkflowState((prev) => ({ ...prev, page: 1 }));

    setPoWorkflowFilters((prev) => {
      const next = { ...(prev || {}) };
      delete next.days;
      const hasStart = startDate && moment(startDate, "DD-MM-YY", true).isValid();
      const hasEnd = endDate && moment(endDate, "DD-MM-YY", true).isValid();

      if (hasStart) {
        next.start_date = moment(startDate, "DD-MM-YY").format("YYYY-MM-DD");
      } else {
        delete next.start_date;
      }
      if (hasEnd) {
        next.end_date = moment(endDate, "DD-MM-YY").format("YYYY-MM-DD");
      } else {
        delete next.end_date;
      }

      if (
        vendorFilter !== undefined &&
        vendorFilter !== null &&
        vendorFilter !== ""
      ) {
        next.vendor = vendorFilter;
      } else {
        delete next.vendor;
      }

      if (selectedCard) {
        next.status = String(selectedCard).toLowerCase();
      } else {
        delete next.status;
      }

      return cleanQueryParams(next);
    });
  };
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("float-rfq-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("rfq_history_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_rfq_history_archive"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const handleScrap = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("float-rfq-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("rfq_history_archive_successfully1"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_rfq_history_archive1"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const handleApplyFilter = () => {
    setSelectedCard(null);
    setClickedFilterButton(true);
    const filterParams = {
      rfq_created_date__gte: startDate,
      rfq_created_date__lte: endDate,
      category_id: categoryTreeFilter,
      vendor: vendorFilter,
      rfq_detail: rfqStatus,
    };

    setState(filterParams);
  };

  const handleEdit = (rfqId) => {
    setCategoryId(rfqId);
  };

  const handleHover = (prNumber) => {
    if (selectedPrNumber !== prNumber) {
      setSelectedPrNumber(prNumber);
    }
    setDotLoaded(false);
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      sorter: true,
    },
    {
      title: "RFQ Number",
      dataIndex: "rfq_number",
      key: "rfq_number",
      sorter: true,
    },
    {
      title: "RFQ Release Date",
      dataIndex: "rfq_approval_date",
      key: "rfq_approval_date",
      sorter: true,
      render: (rfq_approval_date, record) => {
        if (rfq_approval_date) {
          const dateParts = rfq_approval_date.split(" ");
          return dateParts[0];
        } else if (record.rfq_approval_status === "Reject With Reason") {
          return "Rejected";
        } else {
          return "Pending";
        }
      },
    },
    {
      title: "RFQ Approver",
      dataIndex: "rfq_approver",
      key: "rfq_approver",
      sorter: true,
      render: (rfq_approver, record) => {
        const rfq_approval_by = record.rfq_approval_by;
        const rfq_approval_date = record.rfq_approval_date;
        const email = record.rfq_approver_email || "N/A";
        const phone = record.rfq_approver_phone || "N/A";

        if (rfq_approval_date && rfq_approval_by) {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span>{rfq_approver}</span>
              <Tooltip
                color="#094E8F"
                placement="bottom"
                title={
                  <>
                    <div>
                      <strong>Email:</strong> {email}
                    </div>
                    <div>
                      <strong>Phone:</strong> {phone}
                    </div>
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#094E8F",
                    marginLeft: "3px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </div>
          );
        } else if (rfq_approval_date && rfq_approval_by === null) {
          return "RFQ released directly";
        } else if (rfq_approval_by !== null) {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span>{rfq_approver}</span>
              <Tooltip
                color="#094E8F"
                placement="bottom"
                title={
                  <>
                    <div>
                      <strong>Email:</strong> {email}
                    </div>
                    <div>
                      <strong>Phone:</strong> {phone}
                    </div>
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#094E8F",
                    marginLeft: "3px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </div>
          );
        } else {
          return "Pending";
        }
      },
    },
    {
      title: "RFQ Status",
      dataIndex: "rfq_status",
      key: "rfq_status",
      sorter: true,
    },
    {
      title: "Creator Name",
      dataIndex: "rfq_creator_name",
      key: "rfq_creator_name",
      sorter: true,
    },
    {
      title: "Created Date",
      dataIndex: "rfq_created_date",
      key: "rfq_created_date",
      sorter: true,
    },
    {
      title: "Est. Amount",
      dataIndex: "rfq_total_amount",
      key: "rfq_total_amount",
      sorter: true,
      align: "right",
      render: (text) => {
        const formattedAmount = text
          ? `₹ ${text.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`
          : "₹ 0";
        return <span>{formattedAmount}</span>;
      },
    },
    {
      title: "Rejected",
      dataIndex: "rfq_reject_reason",
      key: "rejected",
      sorter: true,
      width: "140px",
      render: (text, record) => {
        if (record.rfq_approval_status !== "Reject With Reason") {
          return null;
        }
        const reason = text || t("no_reason_provided");
        const maxLength = 10;
        const isTruncated = reason.length > maxLength;
        const displayText = isTruncated
          ? `${reason.slice(0, maxLength)}...`
          : reason;

        return (
          <Tooltip color="#094E8F" placement="bottom" title={<>{reason}</>}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span>{displayText}</span>
              {isTruncated && (
                <InfoCircleOutlined
                  style={{
                    color: "#094E8F",
                    cursor: "pointer",
                  }}
                />
              )}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 120,
      render: (record) => {
        return (
          <Space>
            <Popover
              placement="left"
              content={
                <DotRFQStatus
                  prNumber={selectedPrNumber}
                  CompanyID={CompanyID}
                  prID={record.id}
                  setDotLoaded={setDotLoaded}
                />
              }
              title={`Status Of RFQ Number: ${record.rfq_number}
              `}
            >
              <ClockCircleOutlined
                onMouseEnter={() => handleHover(record.rfq_number)}
                style={{ cursor: "pointer" }}
              />
            </Popover>
            <Tooltip title="View RFQ">
              <Link to={`/request-for-quotation-view/${record.id}`}>
                <EyeOutlined />
              </Link>
            </Tooltip>
            {record.rfq_status === "RFQ under Approval" &&
            authUserData()?.permission?.includes("rfq|add_floatrfq") &&
            isCompanyAdmin !== hasCompanyRole ? (
              <Link to={`/request-for-quotation/add-rfq/${record?.id}`}>
                <Editicon onClick={() => handleEdit(record.id)} />
              </Link>
            ) : null}
            {authUserData()?.group_permission?.includes("rfq|add_floatrfq") &&
              authUserData()?.permission?.includes("rfq|delete_rfq") &&
              isCompanyAdmin !== hasCompanyRole &&
              (record.rfq_status === "RFQ under Approval" ? (
                <Popconfirm
                  className="action"
                  title={t("pop_title11")}
                  cancelText={t("pop_cancel")}
                  okText={t("pop_ok")}
                  onConfirm={() => handleScrap(record.id)}
                  placement="left"
                >
                  <Tooltip title="Scrap RFQ">
                    <Archive style={{ cursor: "pointer" }} />
                  </Tooltip>
                </Popconfirm>
              ) : (
                <Popconfirm
                  className="action"
                  title={t("pop_title")}
                  cancelText={t("pop_cancel")}
                  okText={t("pop_ok")}
                  onConfirm={() => handleArchive(record.id)}
                  placement="left"
                >
                  <Tooltip title="Archive" placement="left">
                    <Archive style={{ cursor: "pointer" }} />
                  </Tooltip>
                </Popconfirm>
              ))}

            {(record.rfq_status === "Offer Stage" ||
              record.rfq_status === "Negotiation Stage" ||
              record.rfq_status === "Comparison Approval Stage") &&
              record.purchase_order === false &&
              authUserData()?.group_permission?.includes(
                "rfq|add_floatrfq"
              ) && (
                <Tooltip title="Comparatives" placement="left">
                  {record.category_tree_name === "Cement" ||
                  record.category_tree_name.includes("Sand") || record.category_tree_name.includes("Aggregate") || record.category_tree_name.includes("Earthing") ? (
                    <Link
                      to={`/request-for-quotation/comparatives-by-city/${record.id}`}
                    >
                      <span>|</span>
                      <img
                        style={{ width: "100%" }}
                        src={ComparativeScaleNew}
                        alt=""
                      />
                    </Link>
                  ) : (
                    <Link
                      to={`/request-for-quotation/comparatives-by-city-by-diameter/${record.id}`}
                    >
                      <span>|</span>
                      <img
                        style={{ width: "100%" }}
                        src={ComparativeScaleNew}
                        alt=""
                      />
                    </Link>
                  )}
                </Tooltip>
              )}

            {authUserData()?.group_permission?.includes("rfq|add_floatrfq") &&
              record.purchase_order_approved === true && (
                <Tooltip title="View Comparatives" placement="left">
                  {record.category_tree_name === "Cement" || record.category_tree_name.includes("Earthing")  ? (
                    <Link
                      to={`/request-for-quotation/comparatives-by-city/${record.id}`}
                    >
                      <span>|</span>
                      <img style={{ width: "100%" }} src={Comparativ} alt="" />
                    </Link>
                  ) : (
                    <Link
                      to={`/request-for-quotation/comparatives-by-city-by-diameter/${record.id}`}
                    >
                      <span>|</span>
                      <img style={{ width: "100%" }} src={Comparativ} alt="" />
                    </Link>
                  )}
                </Tooltip>
              )}
          </Space>
        );
      },
    },
  ];

  const WorkflowStageCell = ({ status }) => {
    const isCompleted = status === "completed";
    const isStarted = status === "started";
    const bg = isCompleted ? "#53d462" : isStarted ? "#fa870c" : "#ff0003";
    const text = isCompleted ? "Completed" : isStarted ? "Started" : "Pending";
    return (
      <div
        style={{
          minHeight: 36,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: bg,
          color: "#fff",
          fontWeight: 500,
          fontSize: 12,
          padding: "6px 8px",
        }}
      >
        {text}
      </div>
    );
  };
  WorkflowStageCell.propTypes = { status: PropTypes.string };

  const poWorkflowColumns = [
    {
      title: "Sr. No.",
      dataIndex: "srNo",
      key: "srNo",
      width: 70,
      align: "center",
    },
    {
      title: "Invoice/Challan No.",
      dataIndex: "invoiceChallanNo",
      key: "invoiceChallanNo",
      width: 160,
      render: (text) => text ?? "—",
    },
    {
      title: "Supplier Name",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 180,
      render: (text) => text ?? "—",
    },
    {
      title: "Receipt Date",
      dataIndex: "receiptDate",
      key: "receiptDate",
      width: 110,
      render: (text) => text ?? "—",
    },
    {
      title: "MIN (01)",
      dataIndex: "min",
      key: "min",
      width: 100,
      align: "center",
      render: (_, record) => <WorkflowStageCell status={record.min} />,
    },
    {
      title: "Drafts (02)",
      dataIndex: "drafts",
      key: "drafts",
      width: 100,
      align: "center",
      render: (_, record) => <WorkflowStageCell status={record.drafts} />,
    },
    {
      title: "Good receipt list (03)",
      dataIndex: "good_receipt_list",
      key: "good_receipt_list",
      width: 120,
      align: "center",
      render: (_, record) => <WorkflowStageCell status={record.good_receipt_list} />,
    },
    {
      title: "Inspection (3.1)",
      dataIndex: "inspection",
      key: "inspection",
      width: 100,
      align: "center",
      render: (_, record) => <WorkflowStageCell status={record.inspection} />,
    },
    {
      title: "Distribution (3.2)",
      dataIndex: "distribution",
      key: "distribution",
      width: 110,
      align: "center",
      render: (_, record) => <WorkflowStageCell status={record.distribution} />,
    },
    {
      title: "Site receipt conf (04)",
      dataIndex: "site_receipt_conf",
      key: "site_receipt_conf",
      width: 120,
      align: "center",
      render: (_, record) => <WorkflowStageCell status={record.site_receipt_conf} />,
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   width: 100,
    //   align: "center",
    //   fixed: "right",
    //   render: (_, record) =>
    //     record.document_file_url ? (
    //       <Tooltip title="View document" color="#094E8F">
    //         <Button
    //           type="primary"
    //           size="small"
    //           icon={<EyeOutlined />}
    //           className="SaveGradiantBtn"
    //           onClick={() =>
    //             window.open(record.document_file_url, "_blank", "noopener,noreferrer")
    //           }
    //         />
    //       </Tooltip>
    //     ) : (
    //       <Tooltip title="No document available" color="#094E8F">
    //         <EyeOutlined style={{ fontSize: 18, color: "#d9d9d9", cursor: "not-allowed" }} />
    //       </Tooltip>
    //     ),
    // },
  ];

  const vendorsColumns = [
    {
      title: "Vendor Name",
      dataIndex: "name",
      render: (text) => <>{text}</>,
    },
  ];
  const onSearch = (value) => {
    setInventorySearch(value || "");
    setPoWorkflowState((prev) => ({ ...prev, page: 1 }));

    if (value) {
      setState((prevState) => {
        const {
          rfq_created_date__gte,
          rfq_created_date__lte,
          rfq_status,
          ...rest
        } = prevState;

        return {
          ...rest,
          search: value,
        };
      });
    } else {
      setState((prevState) => {
        const {
          rfq_created_date__gte,
          rfq_created_date__lte,
          search,
          ...rest
        } = prevState;

        return {
          ...rest,
        };
      });
    }
  };
  onSearchRef.current = onSearch;

  const searchCallbackDelayed = (event) => {
    const value = event?.target?.value ?? "";
    if (value === "") {
      inventorySearchDebouncedRef.current.cancel();
      onSearch("");
      return;
    }
    inventorySearchDebouncedRef.current(value);
  };
  const handleClickCard = (status) => {
    // PO workflow cards: call API with `status` like Postman
    setSelectedCard(status || "");
    setPoWorkflowState((prev) => ({ ...prev, page: 1 }));
    setInventorySearch("");
    form.setFieldsValue({ search: "" });

    setPoWorkflowFilters((prev) => {
      const next = { ...(prev || {}) };
      delete next.days;
      if (!status) {
        delete next.status;
      } else {
        next.status = String(status).toLowerCase();
      }
      return cleanQueryParams(next);
    });
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("Inventory Report")} </h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Dashboard</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>{t("Inventory Report")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp" style={{ height: "auto" }}>
              <Form form={form}>
                <Form.Item
                  name="search"
                  initialValue=""
                  style={{ margin: "0" }}
                >
                  <Search
                    allowClear
                    prefix={
                      <img
                        src={SearchIcon}
                        alt="SearchIcon"
                        className="SearchIcon"
                        width={22}
                      />
                    }
                    placeholder={t("pl_search_list")}
                    onChange={searchCallbackDelayed}
                    onSearch={(value) => {
                      inventorySearchDebouncedRef.current.cancel();
                      onSearch(value ?? "");
                    }}
                    style={{
                      width: 250,
                    }}
                  />
                </Form.Item>
              </Form>
            </div>
            {authUserData()?.permission?.includes("rfq|delete_rfq") &&
              isCompanyAdmin !== hasCompanyRole && (
                <Tooltip placement="topLeft" title="Archived Records">
                  <Link
                    to={`/request-for-quotation/history/archive`}
                    className="Archiveicon"
                  >
                    <Archiveicon />
                  </Link>
                </Tooltip>
              )}
          </Space>
        </div>
      </div>
      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          <SubscriptionNotification />
          <section className="Block-Sec-Demo1 mb-5">
            <Row gutter={[15]} className="rfqCard">
              {[
                {
                  status: "",
                  title: "Total PO",
                  count: statusCounts.total_po,
                  icon: TotalCount,
                },
                {
                  status: "Pending",
                  title: "Pending",
                  count: statusCounts.pending_po_count,
                  icon: PendingActions,
                },
                {
                  status: "Completed",
                  title: "Completed",
                  count: statusCounts.complete_po_count,
                  icon: OrderStage,
                },
              ].map((item, index) => (
                <Col key={index}>
                  <div
                    className={`card mb-5 ${
                      selectedCard === item.status ? "active" : ""
                    }`}
                    onClick={() => handleClickCard(item.status)}
                    style={{
                      width: "fit-content",
                    }}
                  >
                    <div className="card-block">
                      <div className="card-box">
                        <div className="card-icon">
                          <img src={item.icon} alt={item.title} width={35} />
                        </div>
                        <div className="card-description">
                          <h3 className="color-blue">{item.title}</h3>
                          <p>{item.count}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </section>
          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="rfq_created_date__gte">
                      <DatePicker
                        format="DD-MM-YY"
                        allowClear
                        placeholder="Select Start Date"
                        value={startDate ? moment(startDate, "DD-MM-YY") : null}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="rfq_created_date__lte">
                      <DatePicker
                        format="DD-MM-YY"
                        allowClear
                        placeholder="Select End Date"
                        value={endDate ? moment(endDate, "DD-MM-YY") : null}
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="vendor">
                      <Select
                        allowClear
                        placeholder="Select Vendor"
                        value={vendorFilter}
                        onChange={handleVendorChange}
                        style={{ minWidth: 220, width: "100%" }}
                        popupMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: 420 }}
                        virtual={false}
                        showSearch
                        optionFilterProp="label"
                        options={[
                          ...vendors.map((v) => ({
                            label: v.vendor_registered_name || v.name || "—",
                            value: v.vendor_registered_name || v.name || "—",
                          })),
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <>
                    <Button
                      type="primary"
                      htmlType="Apply"
                      icon={
                        <Tooltip title="Apply" color="#094E8F">
                          <FilterOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        width: "40px",
                        height: "40px",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        borderRadius: "4px",
                      }}
                      onClick={() => {
                        const shouldApplyVendorStatus =
                          Boolean(startDate) ||
                          Boolean(endDate) ||
                          vendorFilter !== undefined ||
                          Boolean(selectedCard);
                        if (shouldApplyVendorStatus) {
                          handleApplyVendorStatusFilter();
                        }
                        if (startDate || endDate || categoryTreeFilter || vendorFilter) {
                          handleApplyFilter();
                        }
                      }}
                    />

                    <Button
                      htmlType="Reset"
                      type="primary"
                      icon={
                        <Tooltip title="Reset" color="#094E8F">
                          <UndoOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      onClick={
                        clickedFilterButton ? handleReset : handleClearFields
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        width: "40px",
                        height: "40px",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        borderRadius: "4px",
                      }}
                    />
                  </>
                </Space>
              </Form>
            </div>

            <div className="btnscol">
              {selectedRow.length > 0 &&
                authUserData()?.group_permission?.includes(
                  "rfq|add_floatrfq"
                ) && (
                  <Popconfirm
                    className="action"
                    title={t("pop_title")}
                    okText={t("pop_ok")}
                    cancelText={t("pop_cancel")}
                    placement="left"
                    onConfirm={() => handleArchive()}
                  >
                    <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label={t("pl_Archive")}
                    />
                  </Popconfirm>
                )}
            </div>
          </div>
          <div className="tablewrp">
            {/* <Table
               columns={poWorkflowColumns}
               dataSource={poWorkflowData}
              rowSelection={rowSelection}
              dataSource={rfqHistory}
              rowKey={(record) => record.id}
              loading={loading}
              pagination={{
                current: state.page,
                pageSize: state.pagesize,
                defaultCurrent: state.page,
                defaultPageSize: state.pagesize,
                total: totalCount,
                showSizeChanger: true,
                locale: {
                  items_per_page: "Items / Page",
                },
                showTotal: (total) => `Total ${total} items`,
              }}
              scroll={{
                x: "auto",
              }}
              onChange={handleTableChange}
            /> */}
            <Table
                columns={poWorkflowColumns}
                dataSource={poWorkflowData}
                rowKey="id"
                loading={poWorkflowLoading}
                onChange={handlePoWorkflowTableChange}
                pagination={{
                  current: poWorkflowState.page,
                  pageSize: poWorkflowState.page_size,
                  defaultCurrent: poWorkflowState.page,
                  defaultPageSize: poWorkflowState.page_size,
                  total: poWorkflowTotal,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50"],
                  locale: {
                    items_per_page: "Items / Page",
                  },
                  showTotal: (total) => `Total ${total} items`,
                }}
                scroll={{ x: "max-content" }}
                size="small"
                bordered
              />
          </div>
        </div>

        <Modal
          className="ModelPopupSecDemo"
          title={
            <>
              {t("rfq_float_for_price_submission")}
              <div
                className="modal-subtitle"
                style={{ fontSize: "15px", color: "gray" }}
              >
                System with restriction
              </div>
            </>
          }
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[]}
          closable={false}
          keyboard={false}
          maskClosable={false}
          wrapClassName="modal-wrapper"
        >
          <Form
            autoComplete="off"
            ref={formReFloatPriceRef}
            onFinish={handleReFloatPriceSubmit}
          >
            <Row gutter={[15]}>
              <Col md={12} className="TextFeild">
                <Form.Item
                  name="rfq_re_float_price_start_date"
                  rules={[
                    {
                      required: true,
                      message: <Trans>Please Select Start Date Time</Trans>,
                    },
                  ]}
                >
                  <DatePicker
                    showTime={true}
                    showNow={false}
                    placeholder="From date time"
                    format="DD MMMM YYYY  HH:mm"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) =>
                      handleDatepickerChange(date, dateString, "demo_date")
                    }
                    value=""
                  />
                </Form.Item>
              </Col>
              <Col md={12} className="TextFeild">
                <Form.Item
                  name="rfq_re_float_price_end_date"
                  rules={[
                    {
                      required: true,
                      message: <Trans>Please Select End Date Time</Trans>,
                    },
                  ]}
                >
                  <DatePicker
                    showTime={true}
                    showNow={false}
                    placeholder="End date time"
                    format="DD MMMM YYYY  HH:mm"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) =>
                      handleDatepickerChange(date, dateString, "demo_date")
                    }
                    value=""
                  />
                </Form.Item>
              </Col>
              <div className="ModalPopupFooter">
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Submit"
                  label={t("submit")}
                />
              </div>
            </Row>
          </Form>
        </Modal>

        <Modal
          className="ModelPopupSecDemo"
          title={
            <>
              {t("rfq_float_for_price_submission")}
              <div
                className="modal-subtitle"
                style={{ fontSize: "15px", color: "gray" }}
              >
                System without restriction
              </div>
            </>
          }
          open={isWithOutRestrictionReFloatModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[]}
          closable={false}
          keyboard={false}
          maskClosable={false}
          wrapClassName="modal-wrapper"
        >
          <Form
            autoComplete="off"
            ref={formReFloatPriceRef}
            onFinish={handleReFloatPriceSubmit}
          >
            <Row gutter={[15]}>
              <Col md={12} className="TextFeild">
                <Form.Item
                  name="rfq_re_float_price_start_date"
                  rules={[
                    {
                      required: true,
                      message: <Trans>Please Select Start Date Time</Trans>,
                    },
                  ]}
                >
                  <DatePicker
                    showTime={true}
                    showNow={false}
                    placeholder="From date time"
                    format="DD MMMM YYYY  HH:mm"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) =>
                      handleDatepickerChange(date, dateString, "demo_date")
                    }
                    value=""
                  />
                </Form.Item>
              </Col>
              <Col md={12} className="TextFeild">
                <Form.Item
                  name="rfq_re_float_price_end_date"
                  rules={[
                    {
                      required: true,
                      message: <Trans>Please Select End Date Time</Trans>,
                    },
                  ]}
                >
                  <DatePicker
                    showTime={true}
                    showNow={false}
                    placeholder="End date time"
                    format="DD MMMM YYYY  HH:mm"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) =>
                      handleDatepickerChange(date, dateString, "demo_date")
                    }
                    value=""
                  />
                </Form.Item>
              </Col>
            </Row>

            <Table
              columns={vendorsColumns}
              rowSelection={rowSelection}
              dataSource={vendors}
              rowKey={(record) => record.id}
              pagination={false}
              onChange={handleTableChange}
              loading={loading}
            />

            <Row>
              <div className="ModalPopupFooter">
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Submit"
                  label={t("submit")}
                />
              </div>
            </Row>
          </Form>
        </Modal>
      </section>
    </>
  );
};
export default ReportModule;
